import { render, staticRenderFns } from "./personliable.vue?vue&type=template&id=70f223d6&scoped=true&"
import script from "./personliable.vue?vue&type=script&lang=js&"
export * from "./personliable.vue?vue&type=script&lang=js&"
import style0 from "./personliable.vue?vue&type=style&index=0&id=70f223d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f223d6",
  null
  
)

export default component.exports